export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9670.9202621d.jpg";